import { getAllUBOs, updateOrg } from "../../../services/httpCalls";
import Cookies from "js-cookie";

export const handleNext = async ({
  setShowLoader,
  selectionValue,
  handleChange,
  uboValidated,
  notify,
  declarationFormValues,
  partnerState,
}) => {
  setShowLoader(true);
  let orgId = localStorage.getItem("orgId");
  await getAllUBOs(orgId).then(async (res) => {
    if (res.length > 0) {
      if (selectionValue === "inward") {
        if (!uboValidated) {
          notify.error("Please fill out the details for Beneficiary");
          setShowLoader(false);
        } else {
          handleChange(6);
          Cookies.set("currentStage", "6");
          setShowLoader(false);
        }
      } else {
        if (!uboValidated) {
          notify.error("Please fill out the details for Beneficiary");
          setShowLoader(false);
        } else {
          if (
            declarationFormValues?.hasSubstantialUSOwner !== null &&
            declarationFormValues?.hasUSIncomeSource !== null &&
            declarationFormValues?.hasUSPhoneNumber !== null &&
            declarationFormValues?.hasUSResidenceOrMailingAddress !== null &&
            declarationFormValues?.isIncorporatedInUSA !== null &&
            declarationFormValues?.isSubsidiaryOfUSCompany !== null &&
            declarationFormValues?.siToUS !== null &&
            declarationFormValues?.taxableInUS !== null &&
            declarationFormValues?.grantedPOA !== null &&
            uboValidated
          ) {
            await updateOrg(declarationFormValues, orgId)
              .then(async (res) => {
                notify.success("Submitted Declaration");

                if (selectionValue === "both" || Boolean(partnerState.length)) {
                  Cookies.set("currentStage", "6");
                  handleChange(6);
                } else {
                  Cookies.set("currentStage", "7");
                  handleChange(7);
                }
              })
              .catch((err) => {
                notify.error("Not Able to submit Declaration");
              })
              .finally(() => {
                setShowLoader(false);
              });
          } else {
            setShowLoader(false);
            notify.error("Please do fill all the required declarations!");
          }
        }
      }
    } else {
      setShowLoader(false);
      notify.error("Add atleast one UBO");
    }
  });
};
